"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _LogoWrapper = _interopRequireDefault(require("./LogoWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var NutanixLogoIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(NutanixLogoIcon, _React$PureComponent);

  function NutanixLogoIcon() {
    _classCallCheck(this, NutanixLogoIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(NutanixLogoIcon).apply(this, arguments));
  }

  _createClass(NutanixLogoIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_LogoWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'nutanix-logo-icon'),
        viewBox: "0 0 22 16"
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M4.993 15.902c-.064.06-.148.098-.24.098H.355C.16 16 0 15.832 0 15.625c0-.103.04-.196.104-.264L7.81 8.29c.078-.07.127-.17.127-.286 0-.11-.044-.206-.113-.274L.126.66C.05.59 0 .49 0 .374 0 .168.16 0 .355 0h4.398c.093 0 .177.037.24.1l8.298 7.617c.08.07.127.17.127.283 0 .113-.047.215-.123.283l-8.296 7.62zm11.725-.01l-4.267-3.918c-.073-.07-.122-.17-.122-.287 0-.096.035-.185.092-.25l2.196-2.018c.065-.08.158-.127.262-.127.098 0 .187.042.25.11l6.45 5.92c.085.07.14.177.14.298 0 .208-.16.376-.355.376H16.97c-.097 0-.185-.04-.25-.11zm0-15.785c.064-.066.152-.107.25-.107h4.392c.196 0 .354.168.354.374 0 .122-.054.23-.14.298l-6.448 5.922c-.064.067-.153.11-.25.11-.105 0-.198-.048-.263-.124l-2.197-2.016c-.057-.067-.092-.155-.092-.252 0-.115.05-.217.127-.286l4.27-3.92z"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return NutanixLogoIcon;
}(_react.default.PureComponent);

exports.default = NutanixLogoIcon;
NutanixLogoIcon.defaultProps = {
  color: 'inherit'
};
NutanixLogoIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};